import React, { ReactNode } from 'react';
import { HiX } from 'react-icons/hi';

interface Props{
    title?:string;
    children?:ReactNode;
    onClose?: ()=>void;
    buttonText?:string;
}
const Modal:React.FC<Props> = ({ title, children, onClose, buttonText }) => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg w-11/12 md:w-1/3 p-6">
                <div className="flex justify-between items-center">
                    <p className="text-[3rem] font-semibold">{title}</p>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                        <HiX className="text-2xl" />
                    </button>
                </div>
                <div className="mt-4">
                    {children}
                </div>
                <div className="mt-6 flex justify-end">
                    <button
                        onClick={onClose}
                        className="bg-blue-500 text-white py-2 px-4 rounded-lg hover:bg-blue-600 transition duration-300"
                    >
                        {buttonText ?? 'Close'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Modal;
